<div class="detail-container">
  <div class="title-container">
    <span class="title"
      >Details zum {{ typeShortName() }} Test von {{ currentDate() | dateRelativ }} ({{
        currentDate() | date: 'EE, dd.MM.yyyy'
      }})</span
    >
    <!-- <button class="title-button" mat-button (click)="navigateToAssessment()">
    <mat-icon>list</mat-icon> Test öffnen
  </button> -->
    <a
      *ngIf="currentAssessmentRouterLink()"
      [routerLink]="currentAssessmentRouterLink()"
      [queryParams]="currentAssessmentQueryParams()"
      class="title-button"
      mat-button>
      <mat-icon>list</mat-icon> Test öffnen
    </a>
    <!-- <a
      *ngIf="currentAssessmentRouterLink()"
      [routerLink]="currentAssessmentRouterLink()"
      [queryParams]="currentAssessmentQueryParams()"
      target="_blank"
      title="In neuem Tab öffnen"
      class="title-button-new-tab"
      mat-button>
      <mat-icon>open_in_new</mat-icon>
    </a> -->
  </div>
  <div class="buttons">
    <button mat-button [disabled]="!hasPrevious()" (click)="onPrevious()">
      <mat-icon>chevron_left</mat-icon> Vorheriger
    </button>
    <button mat-button [disabled]="!hasNext()" (click)="onNext()">
      Nächster
      <mat-icon iconPositionEnd>chevron_right</mat-icon>
    </button>
  </div>
  <div class="score-table-container">
    <div [ngClass]="{ 'gesamt-score': isTwoSided(), 'gesamt-score-small': !isTwoSided() }">
      <div class="sub-title">Gesamtscore</div>
      <table class="">
        @if (isTwoSided()) {
          <thead>
            <th></th>
            <th class="col head">Links</th>
            <th class="col head">Rechts</th>
          </thead>
        }
        <tbody>
          <tr>
            <td>
              <span class="label">Erfüllung</span>
            </td>
            <td class="col">
              <div class="score-container">
                <app-icf-bar-percent
                  class="subtest-score"
                  [erfuellung]="true"
                  [value]="currentAssessment() | assessmentScorePercent: 'left'"></app-icf-bar-percent>
              </div>
            </td>
            @if (isTwoSided()) {
              <td class="col">
                <div class="score-container">
                  <app-icf-bar-percent
                    class="subtest-score"
                    [erfuellung]="true"
                    [value]="currentAssessment() | assessmentScorePercent: 'right'"></app-icf-bar-percent>
                </div>
              </td>
            }
          </tr>
          @if (type() !== 'CUSTOM') {
            <tr>
              <td>
                <span class="label">Erreicht</span>
              </td>
              <td class="col">
                <div>{{ currentAssessment() | assessmentScore: 'left' }}</div>
              </td>
              @if (isTwoSided()) {
                <td class="col">
                  <div>{{ currentAssessment() | assessmentScore: 'right' }}</div>
                </td>
              }
            </tr>
            <tr>
              <td>
                <span class="label">Zielwert</span>
              </td>
              <td class="col">
                <div>{{ currentAssessment() | assessmentScoreTarget: 'left' }}</div>
                <div>{{ currentAssessment() | assessmentScoreTargetDiff: 'left' }}</div>
              </td>
              @if (isTwoSided()) {
                <td class="col">
                  <div>{{ currentAssessment() | assessmentScoreTarget: 'right' }}</div>
                  <div>{{ currentAssessment() | assessmentScoreTargetDiff: 'right' }}</div>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
      @if (currentAssessment() | assessmentNotes; as note) {
        @if (note && note.length > 0) {
          <div class="note-container">
            <div class="note-row">
              <h4>💬 Kommentar zum Testergebnis</h4>
              <p>{{ note }}</p>
            </div>
          </div>
        }
      }
    </div>
    @switch (type()) {
      @case ('ARAT') {
        <ng-container [ngTemplateOutlet]="arat"></ng-container>
      }
      @case ('NHPT') {
        <ng-container [ngTemplateOutlet]="nhpt"></ng-container>
      }
      @case ('BBS') {
        <ng-container [ngTemplateOutlet]="bbs"></ng-container>
      }
      @case ('FGA') {
        <ng-container [ngTemplateOutlet]="fga"></ng-container>
      }
      @case ('TUG') {
        <ng-container [ngTemplateOutlet]="tug"></ng-container>
      }
      @case ('CUSTOM') {
        <ng-container [ngTemplateOutlet]="custom"></ng-container>
      }
    }
  </div>
  <!-- @if (currentAssessment().note) {
    <div class="note-container">
      <div class="note-row">
        <mat-icon fontSet="material-icons-outlined">feedback</mat-icon>
        <p>{{ currentAssessment().note }}</p>
      </div>
    </div>
  } -->
</div>

<ng-template #custom>
  @if (currentAssessmentImageUrls().length > 0) {
    <div class="subtests">
      <div class="sub-title">Anhang</div>
      <div class="gallery-container">
        <div class="file-gallery">
          <div *ngFor="let file of currentAssessmentImageUrls()" class="file-item">
            <mat-card class="file-thumbnail">
              <img
                *ngIf="file.type === 'image'"
                (click)="openImageInNewTab(file.url)"
                [src]="file.url"
                alt="{{ file.name }}"
                class="thumbnail-image" />
              <div *ngIf="file.type === 'pdf'" class="pdf-thumbnail">
                <span class="pdf-icon">📄</span>
                <a (click)="openImageInNewTab(file.url)" [href]="file.url" target="_blank">{{ file.name }}</a>
              </div>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  }
</ng-template>

<ng-template #bbs>
  <div class="subtests-small">
    <div class="sub-title">Erhöhtes Sturzrisiko</div>
    <table class="">
      <tbody>
        <tr>
          <td>
            <span class="label">Festgestellt</span>
          </td>
          <td class="col">
            <div [innerHTML]="currentAssessment() | bbsScore: 'festgestellt'"></div>
          </td>
        </tr>
        <tr>
          <td>
            <span class="label">Grenzwert</span>
          </td>
          <td class="col">
            <div>{{ currentAssessment() | bbsScore: 'grenzwert' }}</div>
            <div>{{ currentAssessment() | bbsScore: 'diff' }}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #fga>
  <div class="subtests-small">
    <div class="sub-title">Erhöhtes Sturzrisiko</div>
    <table class="">
      <tbody>
        <tr>
          <td>
            <span class="label">Festgestellt</span>
          </td>
          <td class="col">
            <div [innerHTML]="currentAssessment() | bbsScore: 'festgestellt'"></div>
          </td>
        </tr>
        <tr>
          <td>
            <span class="label">Grenzwert</span>
          </td>
          <td class="col">
            <div>{{ currentAssessment() | bbsScore: 'grenzwert' }}</div>
            <div>{{ currentAssessment() | bbsScore: 'diff' }}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #tug>
  <div class="subtests-small">
    <div class="sub-title">Sturzgefahr</div>
    <table class="tug-info">
      <thead>
        <tr>
          <th>Zeit</th>
          <th>Interpretation</th>
        </tr>
      </thead>
      <tbody>
        <tr [ngClass]="{ highlight: currentAssessmentTugValue() >= 0 && currentAssessmentTugValue() < 10 }">
          <td>0 - 9 s</td>
          <td>Keine Sturzgefahr: Patient ist selbstständig mobil.</td>
        </tr>
        <tr [ngClass]="{ highlight: currentAssessmentTugValue() >= 10 && currentAssessmentTugValue() < 20 }">
          <td>10 - 19 s</td>
          <td>
            Leichte Sturzgefahr: Patient ist selbständig hinsichtlich einfacher Transfers, üblicherweise selbstständig
            bei Transfers in Badewanne und Dusche, normalerweise in der Lage, Treppen zu steigen und alleine nach
            draußen zu gehen.
          </td>
        </tr>
        <tr [ngClass]="{ highlight: currentAssessmentTugValue() >= 20 && currentAssessmentTugValue() < 30 }">
          <td>20 - 29 s</td>
          <td>Potentielle Sturzgefahr: Abklärungsbedarf der individuellen Sturzgefahr.</td>
        </tr>
        <tr [ngClass]="{ highlight: currentAssessmentTugValue() >= 30 }">
          <td>ab 30 s</td>
          <td>
            Starke Sturzgefahr: Patient benötigt normalerweise Hilfe mit Sitz- und Toilettentransfers, in die Dusche
            oder Badewanne, beim Treppensteigen. Patient ist nicht in der Lage, alleine nach draußen zu gehen.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #arat>
  <div class="subtests">
    <div class="sub-title">Subtests</div>
    <table class="">
      <thead>
        <th class="large"></th>
        <th class="col head">Links</th>
        <th class="col head">Rechts</th>
      </thead>
      <tbody>
        <tr>
          <td>
            <span class="label">1. Greifen</span>
          </td>
          <td class="col">
            <div class="score-container">
              <app-icf-bar-percent
                class="subtest-score"
                [erfuellung]="true"
                [value]="currentAssessment() | aratScorePercent: 'left' : 'grasp'"></app-icf-bar-percent>
            </div>
          </td>
          <td class="col">
            <div class="score-container">
              <app-icf-bar-percent
                class="subtest-score"
                [erfuellung]="true"
                [value]="currentAssessment() | aratScorePercent: 'right' : 'grasp'"></app-icf-bar-percent>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <span class="label">2. Griff</span>
          </td>
          <td class="col">
            <div class="score-container">
              <app-icf-bar-percent
                class="subtest-score"
                [erfuellung]="true"
                [value]="currentAssessment() | aratScorePercent: 'left' : 'grip'"></app-icf-bar-percent>
            </div>
          </td>
          <td class="col">
            <div class="score-container">
              <app-icf-bar-percent
                class="subtest-score"
                [erfuellung]="true"
                [value]="currentAssessment() | aratScorePercent: 'right' : 'grip'"></app-icf-bar-percent>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <span class="label">3. Präzisionsgriff </span>
          </td>
          <td class="col">
            <div class="score-container">
              <app-icf-bar-percent
                class="subtest-score"
                [erfuellung]="true"
                [value]="currentAssessment() | aratScorePercent: 'left' : 'pinch'"></app-icf-bar-percent>
            </div>
          </td>
          <td class="col">
            <div class="score-container">
              <app-icf-bar-percent
                class="subtest-score"
                [erfuellung]="true"
                [value]="currentAssessment() | aratScorePercent: 'right' : 'pinch'"></app-icf-bar-percent>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <span class="label">4. Basale Armbewergung</span>
          </td>
          <td class="col">
            <div class="score-container">
              <app-icf-bar-percent
                class="subtest-score"
                [erfuellung]="true"
                [value]="currentAssessment() | aratScorePercent: 'left' : 'gross'"></app-icf-bar-percent>
            </div>
          </td>
          <td class="col">
            <div class="score-container">
              <app-icf-bar-percent
                class="subtest-score"
                [erfuellung]="true"
                [value]="currentAssessment() | aratScorePercent: 'right' : 'gross'"></app-icf-bar-percent>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #nhpt>
  @if (currentNhptAssessmentShowSubtest()) {
    <div class="subtests">
      <div class="sub-title">Bewegte Dübel</div>
      <table class="">
        <thead>
          <th></th>
          <th class="col head">Links</th>
          <th class="col head">Rechts</th>
        </thead>
        <tbody>
          <tr>
            <td>
              <span class="label">Erfüllung</span>
            </td>
            <td class="col">
              <div class="score-container">
                <app-icf-bar-percent
                  class="subtest-score"
                  [erfuellung]="true"
                  [value]="currentAssessment() | nhptScore: 'left' : 3"></app-icf-bar-percent>
              </div>
            </td>
            <td class="col">
              <div class="score-container">
                <app-icf-bar-percent
                  class="subtest-score"
                  [erfuellung]="true"
                  [value]="currentAssessment() | nhptScore: 'right' : 3"></app-icf-bar-percent>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="label">Eingesteckt</span>
            </td>
            <td class="col">
              <div>{{ currentAssessment() | nhptScore: 'left' : 1 }} / 9 Düb.</div>
            </td>
            @if (isTwoSided()) {
              <td class="col">
                <div>{{ currentAssessment() | nhptScore: 'right' : 1 }} / 9 Düb.</div>
              </td>
            }
          </tr>
          <tr>
            <td>
              <span class="label">Herausgezogen</span>
            </td>
            <td class="col">
              <div>{{ currentAssessment() | nhptScore: 'left' : 2 }} / 9 Düb.</div>
            </td>
            @if (isTwoSided()) {
              <td class="col">
                <div>{{ currentAssessment() | nhptScore: 'right' : 2 }} / 9 Düb.</div>
              </td>
            }
          </tr>
        </tbody>
      </table>
    </div>
  }
</ng-template>
